'use client'

const ignoredErrorMessages = [
  'ResizeObserver loop limit exceeded',
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
]

let browserAgent
const pendingErrors = []

export function shouldIgnoreBrowserError(error) {
  const message =
    typeof error === 'string'
      ? error
      : typeof error?.message === 'string'
        ? error.message
        : ''

  return (
    ignoredErrorMessages.some((ignored) => message.includes(ignored)) ||
    /Warning:/i.test(message)
  )
}

export function setNewRelicBrowserAgent(agent) {
  browserAgent = agent

  while (pendingErrors.length > 0) {
    const [error, attributes] = pendingErrors.shift()
    browserAgent?.noticeError?.(error, attributes)
  }
}

export function reportBrowserError(error, attributes = {}) {
  try {
    if (shouldIgnoreBrowserError(error)) return

    const agent = browserAgent || globalThis.newrelic
    if (agent?.noticeError) {
      agent.noticeError(error, attributes)
      return
    }

    // An error boundary can run while client instrumentation is still
    // initializing. Keep a small bounded queue and flush it when ready.
    if (pendingErrors.length < 20) pendingErrors.push([error, attributes])
  } catch {
    // Error reporting must never break an error boundary.
  }
}
